define(function (require) {
    'use strict';

    var Backbone = require('backbone');

    return Backbone.Model.extend({
        //initialize: function (options) {
        //    if (!options) {
        //        this.getLocalData();
        //    }
        //    this.on('change', this.setLocalData, this);
        //},
        //
        //getLocalData: function() {
        //    var data = JSON.parse(localStorage.getItem('user-access')) || {};
        //    this.set(data, {silent: true});
        //},
        //
        //setLocalData: function() {
        //    localStorage.setItem('user-access', JSON.stringify(this.toJSON()));
        //}
    });
});
